module.exports = __webpack_public_path__ + "media/images/application/template/tick-ecc77d3960396a1bca26850d0aed097d.svg";